import { __decorate, __param } from '../../../../../../node_modules/tslib/tslib.es6.js';
import { registerEditorContribution } from 'monaco-editor/esm/vs/editor/browser/editorExtensions.js';
import { ICodeEditorService } from 'monaco-editor/esm/vs/editor/browser/services/codeEditorService.js';
import { ReferencesController } from 'monaco-editor/esm/vs/editor/contrib/gotoSymbol/browser/peek/referencesController.js';
import { IConfigurationService } from 'monaco-editor/esm/vs/platform/configuration/common/configuration.js';
import { IContextKeyService } from 'monaco-editor/esm/vs/platform/contextkey/common/contextkey.js';
import { IInstantiationService } from 'monaco-editor/esm/vs/platform/instantiation/common/instantiation.js';
import { INotificationService } from 'monaco-editor/esm/vs/platform/notification/common/notification.js';
import { IStorageService } from 'monaco-editor/esm/vs/platform/storage/common/storage.js';
let WorkbenchReferencesController = class WorkbenchReferencesController extends ReferencesController {
    constructor(editor, contextKeyService, editorService, notificationService, instantiationService, storageService, configurationService) {
        super(false, editor, contextKeyService, editorService, notificationService, instantiationService, storageService, configurationService);
    }
};
WorkbenchReferencesController = ( __decorate([
    ( __param(1, IContextKeyService)),
    ( __param(2, ICodeEditorService)),
    ( __param(3, INotificationService)),
    ( __param(4, IInstantiationService)),
    ( __param(5, IStorageService)),
    ( __param(6, IConfigurationService))
], WorkbenchReferencesController));
registerEditorContribution(ReferencesController.ID, WorkbenchReferencesController, 4 );
export { WorkbenchReferencesController };
